import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hiddenInput", "dropdown", "selected", "pillTemplate"]
  static values = { url: String }

  connect() {
    this.debounceTimer = null
    this.handleOutsideClick = this.closeDropdown.bind(this)
    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }

  onFocus() {
    this.search(this.inputTarget.value.trim())
  }

  onInput() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      this.search(this.inputTarget.value.trim())
    }, 300)
  }

  async search(query) {
    const url = query
      ? `${this.urlValue}?q=${encodeURIComponent(query)}`
      : this.urlValue
    const response = await fetch(url, {
      headers: { "Accept": "text/html" }
    })
    this.dropdownTarget.innerHTML = await response.text()
    this.dropdownTarget.classList.remove("hidden")
  }

  select(event) {
    event.preventDefault()
    const button = event.currentTarget
    this.hiddenInputTarget.value = button.dataset.petId

    const pill = this.pillTemplateTarget.content.cloneNode(true)
    pill.querySelector("[data-role='label']").textContent = button.dataset.petLabel
    this.selectedTarget.replaceChildren(pill)

    this.inputTarget.value = ""
    this.inputTarget.classList.add("hidden")
    this.hideDropdown()
  }

  clear(event) {
    event.preventDefault()
    this.hiddenInputTarget.value = ""
    this.selectedTarget.innerHTML = ""
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
  }

  hideDropdown() {
    this.dropdownTarget.classList.add("hidden")
    this.dropdownTarget.innerHTML = ""
  }

  closeDropdown(event) {
    if (!this.element.contains(event.target)) {
      this.hideDropdown()
    }
  }

  onKeydown(event) {
    if (event.key === "Escape") {
      this.hideDropdown()
    }
  }
}
